import mutations from './roomUtilizationReport.mutations'
import actions from './roomUtilizationReport.actions'
import getters from './roomUtilizationReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
